export type EmailSubscriptionRequest = {
    email: string,
    template_type: EmailTemplateType,
    status?: EmailSubscriptionStatus
}

export enum EmailTemplateType {
    MONTHLY_STATS_EMAIL = "monthly_stats_email",
    GENERIC_EMAIL = "generic_email",
    Monthly_Status_Executive = "monthly_status_executive_email"
}
enum EmailSubscriptionStatus {
    SUBSCRIBED = "subscribed",
    UNSUBSCRIBED = "unsubscribed"
}
